import React from "react";

export const IconOption6 = () => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6901 7.58851C18.5503 7.17214 18.1898 6.86857 17.7559 6.8022L12.7056 6.03047L10.4372 1.19803C10.2437 0.786128 9.83032 0.523926 9.37616 0.523926C8.92169 0.523926 8.5086 0.786128 8.31514 1.19803L6.04639 6.03077L0.996097 6.8025C0.562168 6.86887 0.201751 7.17214 0.0621681 7.58881C-0.0774153 8.00547 0.0279419 8.4644 0.334787 8.77928L4.02288 12.5611L3.14937 17.9114C3.07735 18.3543 3.26514 18.7995 3.63151 19.0584C3.99758 19.3174 4.48092 19.3436 4.87467 19.1263L9.37645 16.6367L13.8782 19.1263C14.0559 19.2245 14.2515 19.2727 14.4461 19.2727C14.683 19.2727 14.9199 19.2007 15.1214 19.0584C15.4878 18.7998 15.6753 18.3546 15.6032 17.9114L14.7297 12.5611L18.4181 8.77928C18.7244 8.4644 18.8297 8.00547 18.6901 7.58851Z"
        fill="#F2F2F2"
      />
    </svg>
  );
};
